// Dependencias
import React, { useState } from 'react';
import Modal from "react-modal";
import './FormEncuestaDatos.css';
import '../FormEncuesta/FormEncuesta.css';
import FormPreguntas from '../Preguntas/FormPreguntas';
import RespuestaNo from '../RespuestaNo/RespuestaNo';

// Sub-componente Puro para los ítems del Modal con "Swag"
const InfoItem = ({ icon, label, value }) => (
  <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
    <div className="info-icon" style={{ width: '40px', height: '40px', background: 'rgba(177, 177, 177, 0.25)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1C212F' }}>
      <i className={`fa-solid ${icon}`}></i>
    </div>
    <div className="info-content" style={{ display: 'flex', flexDirection: 'column' }}>
      <label style={{ fontSize: '12px', textTransform: 'uppercase', color: '#119EEF', margin: 0, letterSpacing: '0.5px' }}>{label}</label>
      <span style={{ fontWeight: '600', color: '#011d46', fontSize: '15px' }}>{value || '---'}</span>
    </div>
  </div>
);

export default function FormEncuestaDatos(props) {
  // 1. Estados Hooks limpios
  const [pregunta1, setpregunta1] = useState('');
  const [modalDetalle, setModalDetalle] = useState(false);
  const [ticketSeleccionado, setTicketSeleccionado] = useState({
    ruc: "",
    empresa: "",
    fecha: "",
    atendidoPor: "",
  });

  // 2. Controladores de eventos del Modal
  const abrirModalWithData = (datosTicket) => {
    setTicketSeleccionado({
      ruc: datosTicket?.Ruc || datosTicket?.ruc || '20491228297',
      empresa: datosTicket?.Razon_Social || datosTicket?.empresa || 'Pale Consultores EIRL',
      fecha: datosTicket?.Fecha_Atencion || '25/05/26',
      atendidoPor: datosTicket?.Atendido_Por || 'Soporte Técnico - Gabriel',
    });
    setModalDetalle(true);
  };

  const closeModal = () => setModalDetalle(false);

  // 3. Guardas de Renderizado (Early Returns)
  if (!props.consultado) {
    return null;
  }

  if (!props.RIncidencia || !props.RIncidencia.resultado || Object.keys(props.RIncidencia).length === 0) {
    return <div></div>;
  }

  // 4. Extracción segura de datos desde las Props de Lumen
  const primerResultado = props.RIncidencia.resultado[0]?.[0] || {};
  const nroTicket = primerResultado.Id_Incidencia || "---";

  const nivelesSat = [
    { v: 1, t: "SI", i: "fa-check", c: "#388E3C" },
    { v: 2, t: "NO", i: "fa-xmark", c: "#D32F2F" }
  ];

  return (
    <div>
      {/* SECCIÓN DEL MODAL */}
      <Modal
        isOpen={modalDetalle}
        className="custom-modal-content"
        overlayClassName="custom-modal-overlay"
        onRequestClose={closeModal}
        ariaHideApp={false} // Evita warnings molestos en modo desarrollo
      >
        <div className="modal-header" style={{ padding: '20px', background: '#119EEF', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #334155', borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}>
          <h3 style={{ margin: 0, color: '#f8fafc', fontSize: '18px' }}>Detalles del Soporte</h3>
          <button
            type="button"
            onClick={closeModal}
            className="btn-close"
            style={{ background: 'none', border: 'none', color: '#f8fafc', fontSize: '24px', cursor: 'pointer' }}
          >
            &times;
          </button>
        </div>
        <div className="modal-body" style={{ padding: '25px' }}>
          <div className="info-grid">
            <InfoItem icon="fa-building" label="Empresa" value={ticketSeleccionado.empresa} />
            <InfoItem icon="fa-id-card" label="RUC" value={ticketSeleccionado.ruc} />
            <InfoItem icon="fa-calendar-days" label="Fecha" value={ticketSeleccionado.fecha} />
            <InfoItem icon="fa-user-tie" label="Atendido por" value={ticketSeleccionado.atendidoPor} />
          </div>
        </div>
      </Modal>

      {/* CUERPO DE LA ENCUESTA */}
      <div className="FormEncuesta">
        <div>
          <h1>Califica tu experiencia</h1>
          <p>
            Nos gustaría que nos cuentes cómo resultó tu experiencia con la atención brindada por nuestro equipo de <b>HelpDesk</b>.
          </p>
          <hr />

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: '15px 0' }}>
            <span><b>Nro Ticket:</b> <span style={{ fontSize: 20 }}>{nroTicket}</span></span>

            <button
              type="button"
              className={`pill-button ${modalDetalle ? 'active' : ''}`}
              style={{
                color: modalDetalle ? 'white' : '#119EEF',
                background: modalDetalle ? '#119EEF' : 'white',
                border: `1px solid #119EEF`,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 14px',
                borderRadius: '20px',
                cursor: 'pointer'
              }}
              onClick={() => abrirModalWithData(primerResultado)}
            >
              <i
                className={`fa-solid fa-magnifying-glass`}
                style={{
                  color: modalDetalle === false ? '#119EEF' : 'white',
                }}></i>
              <span>Ver detalles</span>
            </button>

          </div>

          <p>Ayúdanos a mejorar respondiendo la siguiente encuesta:</p>
        </div>

        {/* BLOQUE DE PREGUNTA PRINCIPAL */}
        <div className="FormEncuesta__bloque2">
          <div>
            <p><b>¿Tu problema fue resuelto?</b></p>
            <div className="pills-wrapper" style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
              {nivelesSat.map((item) => (
                <button
                  key={item.v}
                  type="button"
                  className={`pill-button ${pregunta1 === item.t ? 'active' : ''}`}
                  style={{
                    color: pregunta1 === item.t ? 'white' : item.c,
                    background: pregunta1 === item.t ? item.c : 'white',
                    border: `1px solid ${item.c}`
                  }}
                  onClick={() => setpregunta1(item.t)}
                >
                  <i
                    className={`fa-solid ${item.i}`}
                    style={{
                      color: pregunta1 === item.t ? 'white' : item.c,
                    }}></i>
                  <span>{item.t}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* COMPONENTES CONDICIONALES BAJO DEMANDA */}
        <div style={{ marginTop: '20px' }}>
          {pregunta1 === "SI" && <FormPreguntas RRespuesta={props.RIncidencia} />}
          {pregunta1 === "NO" && <RespuestaNo RRespuesta={props.RIncidencia} />}
        </div>

        <div>
          <p className="FormEncuesta__p" style={{ color: "#119EEF", textAlign: 'center', marginTop: '30px' }}>
            Tu opinión es muy importante para nosotros
          </p>
        </div>
      </div>
    </div>
  );
}





/*
// Dependencias
import React, { useState } from 'react';
import Modal from "react-modal";
import './FormEncuestaDatos.css';
import '../FormEncuesta/FormEncuesta.css';
import DEFAULT_IMAGE from '../../Home/2-Body/3-Solutions/CardSolutions/images/consulta-400.jpg';
import DEFAULT_IMAGE_LOGO from '../../../../images/Logo_720.png';
import FormPreguntas from '../Preguntas/FormPreguntas';
import RespuestaNo from '../RespuestaNo/RespuestaNo';

export default function FormEncuestaDatos(props) {
  const [pregunta1, setpregunta1] = useState('');
  const [modalDetalle, setModalDetalle] = useState(false);
  const [ticketSeleccionado, setTicketSeleccionado] = useState({
    ruc: "",
    atendidoPor: "",
    fecha: "",
    empresa: ""
  });

  const [modalIsOpen, setIsOpen] = useState(false);

  const abrirModal = (ticket) => {
    setTicketSeleccionado(ticket);
    setModalDetalle(true);
  };

  const closeModal = () => setModalDetalle(false);
  

  if (!props.consultado) {
    return (
      null
    );
  }
  else {
    if (Object.keys(props.RIncidencia).length === null) {
      return (
        <div>

        </div>
      )
    }
    else {
      const nroTicket = props.RIncidencia.resultado[1][0].Id_Incidencia;

      const nivelesSat = [
        { v: 1, t: "SI", i: "fa-check", c: "#388E3C" },
        { v: 2, t: "NO", i: "fa-xmark", c: "#D32F2F" }
      ];

      const handleSelection = (pregunta, valor) => {
        this.setState({
          form: {
            ...this.state.form,
            [pregunta]: valor,
          },
        });

      }

      return (
        <div>
          <div>

            <Modal
              isOpen={modalDetalle}
              className="custom-modal-content"
              overlayClassName="custom-modal-overlay"
              onRequestClose={closeModal}
            >
              <div className="modal-header">
                <h3>Detalles del Soporte</h3>
                <button onClick={this.closeModal} className="btn-close">
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="info-grid">
                  <InfoItem icon="fa-building" label="Empresa" value={ticket.empresa} />
                  <InfoItem icon="fa-id-card" label="RUC" value={ticket.ruc} />
                  <InfoItem icon="fa-user-tie" label="Atendido por" value={ticket.atendidoPor} />
                  <InfoItem icon="fa-calendar-days" label="Fecha" value={ticket.fecha} />
                </div>
              </div>
            </Modal>

          </div>
          <div className="FormEncuesta">
            <div>
           /*   <h1>Califica tu experiencia</h1>
              <p>
                Nos gustaría que nos cuentes cómo resultó tu experiencia con la atención brindada por nuestro equipo de <b>HelpDesk</b>.
              </p>
              <hr />
              <div>
                <b>Nro Ticket:</b> <span style={{ fontSize: 20 }}>{nroTicket}</span>
                <button
                  type="button"
                  className={`pill-button ${modalDetalle === false ? 'active' : ''}`}
                  style={{
                    color: modalDetalle === false ? 'white' : '#119EEF',
                    background: modalDetalle === false ? '#119EEF' : 'white',
                    border: `1px solid #119EEF`
                  }}
                  onClick={() => setIsOpen(!modalIsOpen)}
                >
                  <i
                    className={`fa-solid fa-magnifying-glass`}
                    style={{
                      color: modalDetalle === false ? 'white' : '#119EEF',
                    }}></i>
                  <span>Ver detalles</span>
                </button>
              </div>

              <p>
                Ayúdanos a mejorar respondiendo la siguiente encuesta:
              </p>

            </div>


            <div className="FormEncuesta__bloque2">
              <div>
                <div>
                  <p><b>¿Tu problema fue resuelto?</b></p>
                </div>
                <div id="pregunta" className="FormEncuesta__bloque2" value={pregunta1} onChange={(e) => setpregunta1(e.target.value)}>

                  <div className="pills-wrapper">
                    {nivelesSat.map((item) => (
                      <button
                        key={item.v}
                        type="button"
                        className={`pill-button ${pregunta1 === item.t ? 'active' : ''}`}
                        style={{
                          color: pregunta1 === item.t ? 'white' : item.c,
                          background: pregunta1 === item.t ? item.c : 'white',
                          border: `1px solid ${item.c}`
                        }}
                        onClick={() => setpregunta1(item.t)}
                      >
                        <i
                          className={`fa-solid ${item.i}`}
                          style={{
                            color: pregunta1 === item.t ? 'white' : item.c,
                          }}></i>
                        <span>{item.t}</span>
                      </button>
                    ))}
                  </div>


                </div>
              </div>
            </div>
            <div>
              {pregunta1 === "SI" ? <FormPreguntas RRespuesta={props.RIncidencia} /> : pregunta1 === "NO" ? <RespuestaNo RRespuesta={props.RIncidencia} /> : null}
            </div>
            <div>
              <p
                className="FormEncuesta__p"
                style={{ color: "#119EEF", textAlign: 'center' }}>
                Tu opinión es muy importante para nosotros
              </p>
            </div>
          </div>
        </div>

      );

    }

  }

}

*/